import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import TitleAndDesc from '../../components/TitleAndDesc/TitleAndDesc';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import Input from '../../components/Input';
import Confirmation from '../../components/Confirmation';
import { useDispatch, useSelector } from 'react-redux';
import { getSites, createSite, updateSite, deleteSite } from '../../actions/sites';

import { FiEdit2, FiTrash2 } from 'react-icons/fi';

const SitesPage = () => {
  const dispatch = useDispatch();
  const { list, list_loading } = useSelector((state) => state.sites);

  const [modal, setModal] = useState(null);
  const [formData, setFormData] = useState({ name: '', url: '', description: '' });
  const [showConfirm, setShowConfirm] = useState(null);

  useEffect(() => {
    dispatch(getSites());
  }, [dispatch]);

  const handleOpen = (site = null) => {
    setModal(true);
    setFormData(
      site || {
        name: '',
        url: '',
        description: '',
      }
    );
  };

  const handleSubmit = async () => {
    if (!formData.name.trim() || !formData.url.trim()) return;
    if (formData.id) await dispatch(updateSite(formData.id, formData));
    else await dispatch(createSite(formData));
    setModal(false);
  };

  const handleDelete = async (id) => {
    await dispatch(deleteSite(id));
    setShowConfirm(null);
  };

  return (
    <div className={styles.wrapper}>
      <TitleAndDesc title="Список сайтов" desc="" />

      <div className={styles.header}>
        <Button text="Добавить сайт" onClick={() => handleOpen()}></Button>
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.table} cellSpacing="0">
          <thead className={styles.thead}>
            <tr>
              <th>ID</th>
              <th>Имя</th>
              <th>Сайт</th>
              <th>Описание</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {list_loading ? (
              <tr>
                <td colSpan="4" className={styles.loading}>
                  Загрузка сайтов...
                </td>
              </tr>
            ) : list?.length ? (
              list.map((site) => (
                <tr key={site.id} className={styles.row}>
                  <td>{site.id}</td>
                  <td>{site.name}</td>
                  <td>
                    <a href={site.url} target="_blank" rel="noreferrer">
                      {site.url}
                    </a>
                  </td>
                  <td>{site.description || '—'}</td>
                  <td className={styles.actions}>
                    <button
                      className={`${styles.iconBtn} ${styles.editBtn}`}
                      onClick={() => handleOpen(site)}
                      title="Редактировать"
                    >
                      <FiEdit2 />
                    </button>
                    <button
                      className={`${styles.iconBtn} ${styles.deleteBtn}`}
                      onClick={() => setShowConfirm(site)}
                      title="Удалить"
                    >
                      <FiTrash2 />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className={styles.empty}>
                  Нет добавленных сайтов
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {modal && (
        <Modal
          open={modal}
          onClose={() => setModal(false)}
          width={600}
          singleTitle={formData.id ? 'Редактирование сайта' : 'Добавление сайта'}
        >
          <form onSubmit={(e) => e.preventDefault()} className={styles.form}>
            <Input
              name="name"
              placeholder="Имя сайта"
              value={formData.name}
              onChange={(e) =>
                setFormData((p) => ({
                  ...p,
                  name: e.target.value,
                }))
              }
            />
            <Input
              name="url"
              placeholder="https://example.ru"
              value={formData.url}
              onChange={(e) =>
                setFormData((p) => ({
                  ...p,
                  url: e.target.value,
                }))
              }
            />
            <Input
              name="description"
              placeholder="Описание"
              value={formData.description}
              onChange={(e) =>
                setFormData((p) => ({
                  ...p,
                  description: e.target.value,
                }))
              }
            />

            <div className={styles.modalBtns}>
              <Button text={formData.id ? 'Сохранить' : 'Создать'} onClick={handleSubmit} />
              <Button text="Отмена" onClick={() => setModal(false)} type="secondary" />
            </div>
          </form>
        </Modal>
      )}

      {showConfirm && (
        <Confirmation
          absolute
          confirmation={`сайт ${showConfirm.name}`}
          color="#222"
          acceptConfirmation={() => handleDelete(showConfirm.id)}
          rejectConfirmation={() => setShowConfirm(null)}
        />
      )}
    </div>
  );
};

export default SitesPage;
